import React, { Component } from 'react'
import { NominacionDeCuposDialogView } from '../../components/asignacionCupos/NominaciónDeCuposDialogView'
import * as actions from '../../actions'
import { EMPTY_CUPO } from '../../actions/constants'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { FORM_CUPO } from '../../../../config/forms'
import DialogView from '../../../Dialogos/DialogView'

class NominacionDeCuposDialog extends Component {
  render () {
    const { confirmCallback, cancelCallback } = this.props

    return (
      <DialogView
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
        title='Nominación de cupos'
        content={<NominacionDeCuposDialogView
          currentCupo={this.props.cupoNominacion}
          cargador={this.props.cargador}
          corredor={this.props.corredor}
          buscarCorreoCargador={this.props.buscarCorreoCargador}
          buscarCorreoCorredor={this.props.buscarCorreoCorredor}
          resetCorreoCargador={this.props.resetCorreoCargador}
          resetCorreoCorredor={this.props.resetCorreoCorredor}
        />
        }
      />

    )
  }
}

const selector = formValueSelector(FORM_CUPO)

const mapStateToProps = state => {
  return {
    cupoNominacion: state.cupos.cupoNominacion,
    cargador: selector(state, 'remitenteComercial'),
    corredor: selector(state, 'corredorComprador')
  }
}

export default connect(mapStateToProps, actions)(reduxForm({
  form: FORM_CUPO,
  initialValues: EMPTY_CUPO,
  enableReinitialize: true
})(NominacionDeCuposDialog))
